// extracted by mini-css-extract-plugin
module.exports = {"bioSection":"BioSection_bioSection__EdZFw","bio":"BioSection_bio__AzsDc","notShortMode":"BioSection_notShortMode__gpVXc","readmore":"BioSection_readmore__sLhsB"};